document.addEventListener("DOMContentLoaded", async function () {
  const urlParams = new URLSearchParams(window.location.search);
  const phone = urlParams.get("phone");
  if (phone) document.getElementById("phone").value = phone;
  const invoiceNumber = urlParams.get("invoiceNumber");
  if (invoiceNumber) document.getElementById("invoiceNumber").value = invoiceNumber;

  // Получить данные клиента по телефону
  if (phone) {
    try {
      const res = await fetch(`http://vip.pozylov.co.il/apps/customer-info?phone=${encodeURIComponent(phone)}`);
      if (res.ok) {
        const data = await res.json();
        for (const [key, value] of Object.entries(data)) {
          if (key === 'gender') {
            const radio = document.querySelector(`input[name='${key}'][value='${value}']`);
            if (radio) radio.checked = true;
          } else if (key === 'termsApproved' || key === 'acceptsAdvertising' || key === 'customerOrderedBefore') {
            const cb = document.querySelector(`input[name='${key}']`);
            if (cb) cb.checked = !!value;
          } else {
            const input = document.querySelector(`[name='${key}']`);
            if (input) input.value = value;
          }
        }
      } else if (res.status === 404) {
        console.log("Customer is not found");
      } else {
        console.error("Error retrieving client data:", res.status);
      }
    } catch (error) {
      console.error("Error retrieving client data:", error);
    }
  }

  // Логика взаимного блокирования invoiceNumber и customerOrderedBefore
  const invoiceNumberInput = document.getElementById('invoiceNumber');
  const customerOrderedBeforeCheckbox = document.getElementById('customerOrderedBefore');
  const customerOrderedBeforeLabel = customerOrderedBeforeCheckbox ? customerOrderedBeforeCheckbox.closest('label') : null;

  if (invoiceNumberInput && customerOrderedBeforeCheckbox) {
    // Если чекбокс customerOrderedBefore отмечен, блокируем invoiceNumber
    customerOrderedBeforeCheckbox.addEventListener('change', function () {
      if (this.checked) {
        invoiceNumberInput.disabled = true;
        invoiceNumberInput.value = '';
        invoiceNumberInput.style.opacity = '0.5';
      } else {
        invoiceNumberInput.disabled = false;
        invoiceNumberInput.style.opacity = '1';
      }
    });

    // Если в invoiceNumber появляется значение, блокируем чекбокс customerOrderedBefore
    invoiceNumberInput.addEventListener('input', function () {
      this.value = this.value.replace(/[^0-9]/g, '');
      if (this.value.trim() !== '') {
        customerOrderedBeforeCheckbox.disabled = true;
        customerOrderedBeforeCheckbox.checked = false;
        if (customerOrderedBeforeLabel) {
          customerOrderedBeforeLabel.style.opacity = '0.5';
          customerOrderedBeforeLabel.style.pointerEvents = 'none';
        }
      } else {
        customerOrderedBeforeCheckbox.disabled = false;
        if (customerOrderedBeforeLabel) {
          customerOrderedBeforeLabel.style.opacity = '';
          customerOrderedBeforeLabel.style.pointerEvents = '';
        }
      }
    });

    // Проверка после автозаполнения из query параметров
    if (invoiceNumberInput.value.trim() !== '') {
      customerOrderedBeforeCheckbox.disabled = true;
      customerOrderedBeforeCheckbox.checked = false;
      if (customerOrderedBeforeLabel) {
        customerOrderedBeforeLabel.style.opacity = '0.5';
        customerOrderedBeforeLabel.style.pointerEvents = 'none';
      }
    }
  }

  document.getElementById("existingCustomerForm").addEventListener("submit", async function (e) {
    e.preventDefault();
    const form = this;
    const formData = new FormData(form);

    // Собираем все значения
    const payload = Object.fromEntries(formData.entries());

    // Чекбоксы termsApproved и acceptsAdvertising
    payload.termsApproved = form.querySelector("input[name='termsApproved']").checked;
    payload.acceptsAdvertising = form.querySelector("input[name='acceptsAdvertising']").checked;

    // Чекбокс customerOrderedBefore
    payload.customerOrderedBefore = form.querySelector("input[name='customerOrderedBefore']").checked;

    // Валидация обязательных полей
    // invoiceNumber обязателен только если customerOrderedBefore не отмечен
    const invoiceNumberRequired = !payload.customerOrderedBefore;
    const missingFields = [];

    if (!payload.phone) missingFields.push("מספר טלפון");
    if (invoiceNumberRequired && !payload.invoiceNumber) missingFields.push("מספר חשבונית");
    if (!payload.firstName) missingFields.push("שם פרטי");
    if (!payload.lastName) missingFields.push("שם משפחה");
    if (!payload.gender) missingFields.push("מין");
    if (!payload.termsApproved) missingFields.push("אישור תקנון");

    if (missingFields.length > 0) {
      alert("נא למלא את כל השדות החובה: " + missingFields.join(", "));
      return;
    }

    // Валидация email (если указан)
    if (payload.email && payload.email.trim() !== '') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(payload.email)) {
        alert("נא להזין כתובת אימייל תקינה");
        return;
      }
    }

    // Обработка номера телефона: оставляем только последние 9 цифр и добавляем 0 в начало
    const phoneDigits = payload.phone.replace(/[^0-9]/g, '');
    if (phoneDigits.length < 9) {
      alert("נא להזין מספר טלפון תקין");
      return;
    }

    // Берем последние 9 цифр и добавляем 0 в начало
    const last9Digits = phoneDigits.slice(-9);
    payload.phone = '0' + last9Digits;

    const alertElement = document.getElementById('customer-club-form-alert');
    const alertTextElement = alertElement.querySelector('.alert-text');

    try {
      // Отправить обновление данных клиента
      const res = await fetch("http://vip.pozylov.co.il/apps/customer-update", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      if (res.ok) {
        const result = await res.json();
        alertTextElement.textContent = 'תודה, הפרטים שלך עודכנו בהצלחה'
        alertElement.classList.add('success')
        alertElement.style.display = 'block'
        // alert("הפרטים עודכנו!");
        form.reset();
      } else {
        const errorData = await res.json().catch(() => ({}));
        alertTextElement.textContent = `שגיאה בעדכון: ${errorData.error || res.statusText}`
        alertElement.classList.add('error')
        alertElement.style.display = 'block'
        // alert(`שגיאה בעדכון: ${errorData.error || res.statusText}`);
      }
    } catch (error) {
      console.error("Error during update:", error);
      alertTextElement.textContent = 'שגיאה בעדכון - נא לנסות שוב'
      alertElement.classList.add('error')
      alertElement.style.display = 'block'
      // alert("שגיאה בעדכון - נא לנסות שוב");
    }
  });
});